<template>
  <svg :width="width || 928" :height="height || 501" viewBox="0 0 928 501" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M572.239 500.333V388.701L285 388.701L313.375 332.094L628.94 332.094V383.846L763.455 278.273L485.455 278.273L513.83 221.667L927.344 221.667L572.239 500.333Z" fill="white" fill-opacity="0.25"/>
    <path d="M355.105 0V111.632H642.344L613.969 168.239H298.403V116.487L163.889 222.06H441.889L413.513 278.667H0L355.105 0Z" fill="white" fill-opacity="0.25"/>
  </svg>
</template>

<script>
export default {
  props: {
    width: String,
    height: String
  }
}
</script>
